export { default as copyToClipboard } from 'copy-to-clipboard';